import Seller from "./From/Seller";
import Source from "./From/Source";
import Comment from "./Comment";
import React, {Fragment} from "react";
import BoxEditor from "../../BoxEditor";
import PoolList from "./Picking/PoolList";
import Buttons from "../Elements/Buttons";
import List from './List';
import Invoice from "./Invoice";
import Payment from "./Payment";
import Target from "./To/Target";
import Shipping from "./Shipping";
import Notenum from "./Shipping/Notenum";
import VatRate from "./VatRate";

export default class RepurchaseForm extends React.Component {
    render() {
        const componentProps = {...this.props};
        const {props, state, parent} = componentProps;
        const {hidden, labels, actionButtons} = props;
        const Editor = props.editor || BoxEditor;
        return <Fragment>
            <List boxid={props.componentEditor + "ListBox"} {...componentProps} />
            <Editor
                theme="default"
                footer={<Fragment>
                    <Buttons {...componentProps} />
                </Fragment>}
            >
                {
                    props.values.id && <form onSubmit={props.handleSubmit}>
                        <div className="row form-row">
                            <div className="col-md-6">
                                <Seller {...componentProps} />
                            </div>
                            <div className="col-md-6">
                                <Target {...componentProps} />
                            </div>
                        </div>
                        <div className="row form-row">
                            <Invoice {...componentProps} changeActing={true} TabsByName={true} swapTabs={true}/>
                        </div>
                        <div className="row form-row">
                            <Payment {...componentProps} />
                        </div>
                        <div className="row form-row">
                            <Shipping {...componentProps} />
                        </div>
                        <Comment {...componentProps} />
                        <div className="row form-row">
                            <div className="col-md-12">
                                <VatRate {...componentProps} />
                            </div>
                        </div>
                        <PoolList {...componentProps} control={{visible: false}}/>
                    </form>
                }
            </Editor>
        </Fragment>;
    }
}